import amount from './amount'
import loanId from './loan-id'

export default {
  amount,
  loanId,
}
